import React, { type CSSProperties } from 'react';
import classnames from 'classnames';

import type { PaperProps as Props } from './types';
import styles from './paper.module.css';

const Paper = ({ className = '', padding = 10, children }: Props) => (
  <div
    className={classnames(styles.container, className)}
    style={{ '--padding': `${padding}px` } as CSSProperties}
  >
    {children}
  </div>
);

export default Paper;
